import de from '../locales/de/common.json';
import en from '../locales/en/common.json';
import es from '../locales/es/common.json';
import fr from '../locales/fr/common.json';
import it from '../locales/it/common.json';
import nl from '../locales/nl/common.json';

export const TRANSLATIONS = {
    de,
    en,
    es,
    fr,
    it,
    nl
};